export default "__VITE_ASSET__Czd54nPB__"